import Spinner from './spiner';
export default Spinner;